import React from "react";
export { default as HRMSicon } from "./HRMSicon/HRMSicon";
export { default as TabNavbar } from "./TabNavbar"
export { default as CustomInput } from './InputBox'
export { default as CustomDatePicker } from './CustomeDatePicker'
export { default as CustomSelectBox } from './CustomeSelectBox'
export { default as CustomPhoneNumberInput } from './CustomePhoneNumberInput'
export const Loader = React.lazy(() => import('./Loader/Loader'))
export const SkeletonComponent = React.lazy(() => import("./Skeleton/Skeleton"))
export { default as HRMSTable } from "./Table/Table"
export { default as HRMSModal } from "./Modal"
export { default as CustomTextArea } from './CustomTextAreaBox'
export { default as DebounceInputBox } from './DebounceInputBox'
export { default as ActionButtonGroups } from './ActionButtonGroups'
export { default as LazySelectBox } from './LazySelectBox'
